import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';

@Injectable({
    providedIn: 'root'
})
export class LazadaGetShipmentProviderService extends BaseApiTemplateService<any> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'lazada/shipment-provider';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = this.url;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'lazada/shipment-provider';
        this.httpClient = http;
    }

    getShipmentProvider(branch_guid, apiVisa: ApiVisa) {
        if (this.endpoint_path && apiVisa.api_domain_url) {
          this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
        }
        const url = this.apiUrl + '?branch_guid=' + branch_guid;
        console.log("getShipmentProvider", url)
        return this.httpClient.get(url, this.getHttpHeader(apiVisa));
      }
}
